import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../Images/footerlogo.svg";
import F2 from "../Images/insta.png";
import F3 from "../Images/facebook.png";
import F4 from "../Images/youtube.png";
import F5 from "../Images/gmb.svg";
import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { FaPhoneAlt } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";

const Footer = () => {
  useEffect(() => {
    import("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <>
      <footer
        className="footer p-0 "
        style={{
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
        }}
      >
        <Row className="d-flex justify-content-center mt-md-5 mt-2 mb-md-5 mb-2  mx-1">
          <Col md={10}>
            <div className=" py-4">
              <div className="row d-flex">
                <div className="col-md-9">
                  <div className="row row-cols-2 row-cols-md-3 g-3">
                    {/* Competitive Research */}
                    <div className="col">
                      <h6>
                        <strong>Competitive Research</strong>
                      </h6>
                      <div className="mb-1">
                        <a
                          href="/da-pa-checker"
                          className="text-decoration-none text-dark"
                        >
                          Domain Overview
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/serp-simulator"
                          className="text-decoration-none text-dark"
                        >
                          SERP Simulator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/keyword-gap"
                          className="text-decoration-none text-dark"
                        >
                          Keyword Gap
                        </a>
                      </div>
                    </div>

                    {/* Page SEO */}
                    <div className="col">
                      <h6>
                        <strong>Page SEO</strong>
                      </h6>
                      <div className="mb-1">
                        <a
                          href="/seo-Inspector"
                          className="text-decoration-none text-dark"
                        >
                          SEO Inspector
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/structured-data"
                          className="text-decoration-none text-dark"
                        >
                          Structure Data
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/on-page-seo-tool"
                          className="text-decoration-none text-dark"
                        >
                          On Page Seo
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/manage-robots-txt"
                          className="text-decoration-none text-dark"
                        >
                          Robots.txt
                        </a>
                      </div>
                    </div>

                    {/* Content Checker */}
                    <div className="col">
                      <h6>
                        <strong>Content Checker</strong>
                      </h6>
                      <div className="mb-1">
                        <a
                          href="/bix-content-generator"
                          className="text-decoration-none text-dark"
                        >
                         Bix Content Generator
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/content-quality-checker"
                          className="text-decoration-none text-dark"
                        >
                          Quality Content Checker
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/bix-humanizer"
                          className="text-decoration-none text-dark"
                        >
                         Bix Humanizer
                        </a>
                      </div>
                    </div>

                    {/* Backlinks */}
                    <div className="col">
                      <h6>
                        <strong>Backlinks</strong>
                      </h6>
                    
                      <div className="mb-1">
                        <a
                          href="/backlink-checker"
                          className="text-decoration-none text-dark"
                        >
                          Backlink Checker
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/link-building-tool"
                          className="text-decoration-none text-dark"
                        >
                          Link Building Tool
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/top-pages"
                          className="text-decoration-none text-dark"
                        >
                          Top Pages
                        </a>
                      </div>
                    </div>

                    {/* Keyword Research */}
                    <div className="col">
                      <h6>
                        <strong>Keyword Research</strong>
                      </h6>
                      <div className="mb-1">
                        <a
                          href="/best-keyword-research-tool"
                          className="text-decoration-none text-dark"
                        >
                          Bix keyword Research
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/bix-keyword-analyzer"
                          className="text-decoration-none text-dark"
                        >
                          Domain Ranking Keyword
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/construct-your-seo-success-with-keyword-builder"
                          className="text-decoration-none text-dark"
                        >
                          Keyword Builder
                        </a>
                      </div>
                      {/* <div className="mb-1">
                        <a
                          href="/keyword-position-tracker"
                          className="text-decoration-none text-dark"
                        >
                          Position Tracker
                        </a>
                      </div> */}
                    </div>

                    {/* Bix Labs with Google */}
                    <div className="col">
                      <h6>
                        <strong>Bix Labs with Google</strong>
                      </h6>
                      <div className="mb-1">
                        <a
                          href="/google-analytics"
                          className="text-decoration-none text-dark"
                        >
                          Google Analytics
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/search-console"
                          className="text-decoration-none text-dark"
                        >
                          Google Search Console
                        </a>
                      </div>
                      <div className="mb-1">
                        <a
                          href="/trending-now-on-google"
                          className="text-decoration-none text-dark"
                        >
                          Google Trends
                        </a>
                      </div>
                    </div>
                  </div>
                 
                </div>

                {/* Right side - Connect With Us */}
                <div className="col-md-3 border-start ps-md-4">
                  <h5 className="mb-3">
                    <strong>Connect With Us</strong>
                  </h5>
                  <div className="d-flex gap-2 mb-3">
                    <a
                      href="https://www.facebook.com/seobixofficial/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F2}
                        alt="Facebook"
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/seobixofficial/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F3}
                        alt="Instagram"
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/@Seobix"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F4}
                        alt="YouTube"
                      />
                    </a>
                    <a
                      href="https://share.google/cwogc8QB3FsQa14Gs"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        style={{ height: "2.6rem" }}
                        src={F5}
                        alt="Gmb"
                      />
                    </a>
                  </div>

                  <div className="mb-3">
                    <a
                      href="/contact-us"
                      className="text-decoration-none text-dark d-block"
                    >
                      <strong>Contact the Help team</strong>
                    </a>
                    <address
                      className="mt-2 mb-3"
                      style={{ fontStyle: "normal" , fontSize:".9rem", fontWeight:"600" }}
                    >
                      ITHUM Tower, B-212A, Block A, <br />
                      Industrial Area, Sector 62, <br />
                      Noida, Uttar Pradesh – 201301
                    </address>
                    <div className="mb-3">
                      <a
                        href="mailto:support@seobix.com"
                        className="text-decoration-none text-primary me-3"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <strong>support@seobix.com</strong>
                      </a>
                      <br />
                      {/* <strong>+91 7303484700</strong> */}
                      <br />
                      {/* <div className="d-flex align-items-center mt-3 gap-3">
                        <a
                          href="tel:7303484700"
                          className="text-decoration-none text-primary d-flex align-items-center gap-2"
                        >
                          <FaPhoneAlt style={{ fontSize: "1.5rem" }} />
                        </a>
                        <a
                          href="tel:7303484700"
                          className="text-decoration-none text-primary d-flex align-items-center gap-2"
                        >
                          <IoLogoWhatsapp
                            style={{ fontSize: "2rem", color: "green" }}
                          />
                        </a>
                      </div> */}
                    </div>
                  </div>

                  <a
                    href="/register"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button
                      className="btn rounded-pill text-white px-3 py-1"
                      style={{
                        background: "linear-gradient(90deg, #574981, #0075a8)",
                      }}
                    >
                      Sign Up now!
                    </button>
                  </a>
                  <br />
                  <div className="mt-2">
                    <a href="/partners">
                      <button
                        className="btn rounded-pill text-white px-3 py-1"
                        style={{
                          background:
                            "linear-gradient(90deg, #574981, #0075a8)",
                        }}
                      >
                        Be Our Partners
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <p className="text-center m-0 p-0"> Managed and Owned By SEOBIX</p>
           
          </Col>
        </Row>
      </footer>
      <div className="py-4" style={{ backgroundColor: "#002f50" }}>
        <Row className="d-flex justify-content-center mx-1">
          <Col md={10}>
            <div className=" d-flex flex-column flex-md-row align-items-center justify-content-between">
              <div className="mb-2 mb-md-0">
                <Link to="/">
                  <img
                    style={{ height: "2rem" }}
                    src={logo}
                    alt="seobix logo"
                  />
                </Link>
              </div>
              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-md-end gap-3 text-white small">
                {/* <p className="mb-0">
                  © 2025 SEOBIX Pvt. Ltd. All rights reserved. SEOBIX is a
                  registered trademark.
                </p> */}
                <a
                  className="text-white text-decoration-none"
                  href="/privacy-policy"
                >
                  Privacy Policy
                </a>
                <a
                  className="text-white text-decoration-none"
                  href="/terms-and-conditions"
                >
                  Terms of Use
                </a>
                <a className="text-white text-decoration-none" href="/faq">
                  FAQ
                </a>
              </div>
            </div>
          </Col>
        </Row>{" "}
      </div>
    </>
  );
};

export default Footer;
